import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import './resources-list-item.css';

class ResourcesListItem extends PureComponent
{
  static propTypes = {
    index: PropTypes.number.isRequired,
    isSelected: PropTypes.bool,
    insertValidation: PropTypes.func.isRequired,
    onSelect: PropTypes.func.isRequired,
    onInsert: PropTypes.func.isRequired,
    onChangeLocation: PropTypes.func.isRequired,
    resource: PropTypes.shape({
      isDirectory: PropTypes.bool
    }).isRequired
  };

  static defaultProps = {
    isSelected: false,
    isDirectory: false
  };

  handleSelect = () =>
  {
    const { onSelect, index } = this.props;
    onSelect(index);
  };

  handleChangeLocation = () =>
  {
    const {
      onChangeLocation,
      index,
      onInsert,
      resource,
      insertValidation
    } = this.props;

    const { isDirectory } = resource;

    if (isDirectory)
    {
      return onChangeLocation(index);
    }

    if (insertValidation(resource))
    {
      return onInsert(resource);
    }
  };

  render()
  {
    const {
      children,
      ...delegatedProps
    } = this.props;

    return children({
      ...delegatedProps,
      onSelect: this.handleSelect,
      onChangeLocation: this.handleChangeLocation
    });
  }
}

export default ResourcesListItem;